<template>
    <div>
        <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
        <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
            <v-card>
                <v-card-title class="text-h5 pa-4">
                    Edit User Guide
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-6">
                    <v-form ref="form" v-model="valid">

                        <v-text-field v-model="formData.guide_main_title" label="Guide Main Title" variant="outlined" 
                            density="compact" :rules="[(v) => !!v || 'Guide Main Title is required']" />

                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey" variant="text" @click="handleClose">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" variant="flat" :loading="loading" @click="handleSubmit">
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_user_guide_topic } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
    name: "EditUserGuideDialog",
    components: {
        SnackbarComponent,
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        UserGuide: {
            type: Object,
            required: true,
        },
    },
    emits: ["update:modelValue", "updated"],
    data() {
        return {
            valid: false,
            loading: false,
            formData: {
                guide_main_title: "",
                guide_topic_status: "ACTIVE",
            },
            snackbar: {
                show: false,
                message: "",
                color: "success",
            },
        };
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    watch: {
        modelValue(val) {
            if (val && this.UserGuide) {
                this.formData.guide_main_title = this.UserGuide.title;
            } else {
                this.resetForm();
            }
        }
    },
    methods: {
        handleClose() {
            this.dialog = false;
            this.resetForm();
        },
        resetForm() {
            this.formData = {
                guide_main_title: "",
                guide_topic_status: "ACTIVE",
            };

            this.loading = false;

            this.$refs.form?.resetValidation();
        },
        async handleSubmit() {
            this.loading = true;
            const { valid } = await this.$refs.form.validate();

            if (!valid) return;
            try {
                const input = {
                    guide_topic_id: this.UserGuide.guide_topic_id,
                    title: this.formData.guide_main_title,
                };

                const response = await client.graphql({
                    query: edit_user_guide_topic,
                    variables: {
                        input,
                    },
                });

                const responseData = JSON.parse(response.data.edit_user_guide_topic);

                if (responseData.status === "SUCCESS") {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "User Guide updated successfully.",
                        color: "success",
                    };

                    this.$emit("updated");
                    this.handleClose();
                } else {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "Failed to update User Guide.",
                        color: "error",
                    };
                }
            } catch (error) {
                console.error(error);

                this.snackbar = {
                    show: true,
                    message: error.message || "Failed to update User Guide.",
                    color: "error",
                };
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped></style>
